// components
import GridPageAbstract from '../../GridPageAbstract';
import { CoinBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class CoinCurrencyPairsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'coinCurrencyPairs';
        this.Server = this.props.context.getState().server.coinCurrencyPairs;

        this.headerStartIcon = CoinBulkIcon;

        this.searchFields = ['coin.name', 'currency.name'];

        this.hiddenColumns = config?.hiddenColumns?.coinCurrencyPairs || [];

        this.Head = [
            {
                id: 'coinsId',
                sortField: 'coin.name',
                label: 'coin',
                object: 'coin',
                alignRight: false,
                cell: 'Select',
                from: 'coins',
                display: 'name',
                filterCell: 'Context',
                filterBy: 'coins'
            },
            {
                id: 'currenciesId',
                label: 'currency',
                object: 'currency',
                alignRight: false,
                cell: 'Select',
                from: 'currencies',
                display: 'name',
                filterCell: 'Context',
                filterBy: 'currencies'
            },
            { id: 'rule', label: 'rule', alignRight: false, cell: 'Text' },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
